// extracted by mini-css-extract-plugin
export default {"cardContainer":"work_cardContainer__y6IbP","card":"work_card__VDXcV","desc":"work_desc__QPENr","imageContainer":"work_imageContainer__tUqEm","inner":"work_inner__k6mL4"};